import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';

export type GenerateOtpResponse = { otp: string; expiresAtMs: number };
export type VerifyOtpResponse = { token: string; expiresAtMs: number };

export const generateOtp = async (): Promise<GetResponseType<GenerateOtpResponse>> => {
  return ApiClient.post<GenerateOtpResponse>(
    `${window.config.api_endpoint}/auth/otp/generate`,
    {},
    WITH_AUTH
  );
};

export const verifyOtp = async (otp: string): Promise<GetResponseType<VerifyOtpResponse>> => {
  return ApiClient.post<VerifyOtpResponse>(
    `${window.config.api_endpoint}/auth/otp/verify`,
    { otp },
    false
  );
};
